"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value, other) {
  if (value === other) {
    return true;
  }

  if (value instanceof Object && other instanceof Object && Object.keys(value).length === Object.keys(other).length) {
    return !Object.keys(value).some(function (keyValue) {
      return !(keyValue in other && value[keyValue] === other[keyValue]);
    });
  }

  return false;
};